// ========================================================================
// 📁 constants.js
// Purpose: Centralized configuration and static data. Easy to update.
// ========================================================================

import {AlertTriangle, CheckCircle2, Clock, Eye} from "lucide-react";

const API_BASE_URL = process.env.REACT_APP_SERVER_URL;
const USER_TOKEN = localStorage.getItem("user-token");

const BRANDS = ["Coca-Cola", "Thumsup", "Sprite", "Maaza", "Charged", "Others"];
const PROGRAMMES = [
    { "_id": "6869dc397d00ed4c1204c2b2", "name": "Coke Saathi" },
    { "_id": "6869dc397d00ed4c1204c2b5", "name": "Land Mark Outlet" },
    { "_id": "6869dc397d00ed4c1204c2b3", "name": "Ring Of Magic" },
    { "_id": "6869dc397d00ed4c1204c2b4", "name": "Thumsup Biryani" },
    { "_id": "6869dc397d00ed4c1204c2b6", "name": "Visit Route" }
];

const STATUS_CONFIG = {
    completed: { color: "text-emerald-600", bg: "bg-emerald-50", border: "border-emerald-200", icon: <CheckCircle2 className="w-5 h-5 text-emerald-600" /> },
    ongoing: { color: "text-blue-600", bg: "bg-blue-50", border: "border-blue-200", icon: <Clock className="w-5 h-5 text-blue-600" /> },
    pending: { color: "text-amber-600", bg: "bg-amber-50", border: "border-amber-200", icon: <AlertTriangle className="w-5 h-5 text-amber-600" /> },
    default: { color: "text-gray-600", bg: "bg-gray-50", border: "border-gray-200", icon: <Eye className="w-5 h-5 text-gray-600" /> }
};

const getStatusConfig = (status) => STATUS_CONFIG[status] || STATUS_CONFIG.default;

const formatTimestamp = (timestamp) => {
    if (!timestamp) return "N/A";
    try {
        return new Date(timestamp).toLocaleString("en-IN", {
            dateStyle: "medium",
            timeStyle: "short",
        });
    } catch (error) {
        return "Invalid Date";
    }
};

export {
    BRANDS,
    API_BASE_URL,
    formatTimestamp,
    getStatusConfig,
    PROGRAMMES,
    STATUS_CONFIG,
    USER_TOKEN
}
